import React from 'react'

export default ({ ...props }) => (
  <svg width='12' height='7' viewBox='0 0 12 7' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M0.0010909 0.55588C0.0010909 0.413646 0.054549 0.271412 0.160374 0.162514C0.373116 -0.0541712 0.718958 -0.0541712 0.9317 0.162514L6.00041 5.32517L11.0691 0.162514C11.2819 -0.0541712 11.6277 -0.0541712 11.8404 0.162514C12.0532 0.379198 12.0532 0.73145 11.8404 0.948134L6.38553 6.50415C6.17278 6.72084 5.82694 6.72084 5.6142 6.50415L0.159283 0.948134C0.0523671 0.839236 0 0.697002 0 0.554768L0.0010909 0.55588Z'
      fill='#0D0D0D'
    />
  </svg>
)
